import React from 'react'

import SignIn from './auth/SignIn'

import EmployeesList from './employees/List'
import Employee from './employees/Show'
import CreateEmployee from './employees/Create'

import CompaniesList from './companies/List'
import Company from './companies/Show'
import EditCompany from './companies/Edit'

import VerifyPassword from './auth/VerifyPassword'
import ResetPassword from './auth/ResetPassword'
import ChangePassword from './password/Change'

import Orders from './orders/List'
import Order from './orders/Show'

import Transactions from './transactions/List'

import Invoices from './invoices/List'

import Settings from './settings/List'

export type RouteOption = {
  name: string
  exact: boolean
  strict: boolean
  path: string
  component: React.ComponentType
}

export const defaultRoute: RouteOption = CompaniesList

export const unauthorizedRoutes: RouteOption[] = [
  VerifyPassword,
  ResetPassword,
  SignIn,
]

export const authorizedRoutes: RouteOption[] = [
  CreateEmployee,
  EmployeesList,
  Employee,
  CompaniesList,
  Company,
  EditCompany,
  ChangePassword,
  Orders,
  Order,
  Transactions,
  Settings,
  Invoices,
]
